<template>
  <form @submit.prevent="onSubmit">
    <div class="form-group" :class="{'has-error has-feedback': email && !emailValid}">
      <label for="email">Email Address</label>
      <input v-model="email" type="email" class="form-control" id="email" name="email" required />
      <span v-if="email && !emailValid" class="help-block">Email has incorrect format.</span>
    </div>

    <div class="dropdown" :class="{open: passwordFocused}">
      <div class="form-group" :class="{'has-error has-feedback': password && !passwordValid}">
        <label for="password">Password</label>
        <input
          v-model="password"
          :type="textSecurity ? 'text' : 'password'"
          :class="{'text-security-disc': textSecurity}"
          class="form-control"
          id="password"
          @focus="passwordFocused = true"
          @blur="passwordFocused = false"
          autocomplete="new-password"
        />
        <span v-if="password && !passwordValid" class="help-block">Password doesn't satisfy the requirements.</span>
      </div>
      <div class="dropdown-menu p-4 px-md-5 pt-md-4 pb-md-5">
        <password-requirements
          :password="password"
          @validity-change="onPasswordValidityChange($event)"
        ></password-requirements>
      </div>
    </div>

    <div class="form-group" :class="{'has-error has-feedback': passwordConfirmation && !passwordConfirmationValid}">
      <label for="password-confirmation">Confirm Password</label>
      <input
        v-model="passwordConfirmation"
        :type="textSecurity ? 'text' : 'password'"
        autocomplete="new-password"
        class="form-control"
        :class="{'text-security-disc': textSecurity}"
        id="password-confirmation"
        name="password-confirmation"
      />
      <span v-if="passwordConfirmation && !passwordConfirmationValid" class="help-block">Passwords don't match.</span>
    </div>

    <div class="form-group">
      <label for="first-name">First Name</label>
      <input v-model="firstName" type="text" class="form-control" id="first-name" name="first-name" />
    </div>

    <div class="form-group">
      <label for="last-name">Last Name</label>
      <input v-model="lastName" type="text" class="form-control" id="last-name" name="last-name" />
    </div>

    <div class="form-group">
      <label for="company-name">Company Name</label>
      <input v-model="companyName" type="text" class="form-control" id="company-name" name="company-name" />
    </div>

    <registration-form-broker-dealer v-if="brokerDealerEnabled" v-model="brokerDealerId" :broker-dealers="brokerDealers" :label="brokerDealerLabel" />

    <div v-if="globalError" class="alert alert-danger mt-5" role="alert">
      {{ globalError }}
    </div>

    <div class="text-center py-3">
      <button :disabled="!formValid || loading" type="submit" class="btn btn-primary btn-lg">
        {{ loading ? 'Registering...' : 'Register' }}
      </button>
    </div>
  </form>
</template>

<script>
import PasswordRequirements from '../auth/PasswordRequirements';
import RegistrationFormBrokerDealer from './RegistrationFormBrokerDealer.vue';

export default {
  name: 'registration-form',
  components: {PasswordRequirements, RegistrationFormBrokerDealer},
  props: {
    brokerDealerEnabled: {
      type: Boolean,
    },
    brokerDealerLabel: {
      type: String,
    },
    brokerDealers: {
      type: Array,
    },
    globalError: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      passwordFocused: false,
      passwordValid: false,
      passwordConfirmation: '',
      firstName: '',
      lastName: '',
      companyName: '',
      brokerDealerId: '',
      textSecurity: CSS.supports('(-webkit-text-security: disc)'),
    };
  },
  computed: {
    brokerDealerValid() {
      return !this.brokerDealerEnabled || this.brokerDealerId;
    },
    companyNameValid() {
      return this.companyName.length > 0;
    },
    emailValid() {
      return /^[a-z0-9._%+-]+@[a-z0-9][a-z0-9.-]*\.[a-z]{2,63}$/.test(this.email);
    },
    firstNameValid() {
      return this.firstName.length > 0;
    },
    formValid() {
      return (
        this.emailValid &&
        this.passwordValid &&
        this.passwordConfirmationValid &&
        this.firstNameValid &&
        this.lastNameValid &&
        this.companyNameValid &&
        this.brokerDealerValid
      );
    },
    lastNameValid() {
      return this.lastName.length > 0;
    },
    passwordConfirmationValid() {
      return this.password === this.passwordConfirmation;
    },
  },
  methods: {
    onPasswordValidityChange(valid) {
      this.passwordValid = valid;
    },
    onSubmit() {
      if (!this.formValid) {
        return;
      }

      this.$emit('register', {
        email: this.email,
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        brokerDealerId: this.brokerDealerEnabled ? this.brokerDealerId : undefined,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-security-disc {
  -webkit-text-security: disc;
}
</style>
